export function changeDocumentTitle(title) {
     document.title = "Ctrade - " + title;
}